import { render, staticRenderFns } from "./DesignRirekishoMainImageCard.vue?vue&type=template&id=2bf7af5b"
import script from "./DesignRirekishoMainImageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekishoMainImageCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports